module.exports = __webpack_public_path__ + "static/img/s39.25aebac0.png";